export const RPC_SOCIAL_PLATFORM_ENDPOINTS = {
    GET_LIST: "/get_social_media_list",
};
